module.exports = __webpack_public_path__ + "static/greymuslin-ad62484fd0265c3a57ceff407316fa04.jpeg";